import { useCallback, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { actionAlert, actionUserLocationUpdate, actionWeathcer, AppDispatch } from "store/store";
import { DEFAULT_CENTER_POS, getCurrentLocationOptional } from "utils/common";
import { kakaomapAddressFromCoords } from "utils/kakaomap/common";
import { coordsFindLocation } from "utils/weather/korLocation";
import { MarkerPositionType } from "types/kakaoComon";

interface CurrentLocationProps {
  enabled: boolean;
  syncWeather?: boolean;
  onResolved?: (coords: MarkerPositionType) => void;
}

export default function CurrentLocation({ enabled, syncWeather = false, onResolved }: CurrentLocationProps) {
  const dispatch = useDispatch<AppDispatch>();
  const requestedRef = useRef(false);

  const getAddressFromCoords = useCallback(async (coordsPos: kakao.maps.LatLng) => {
    try {
      const position = await kakaomapAddressFromCoords(coordsPos);
      const address = JSON.parse(position)[0];
      const coords = {lat:coordsPos.getLat(), lng:coordsPos.getLng()}
      dispatch(actionUserLocationUpdate({...address, coords: coords }));

      if (syncWeather) {
        const locationData = coordsFindLocation(coords); 
        dispatch(actionWeathcer({coords:coords, location:locationData }));
      }
      onResolved?.(coords);
    } catch (error) {
      console.log("현재 위치 가져오기 에러.. 😢 "+error);
      dispatch(actionAlert({ titMessage: "현재 위치를 확인하지 못했어요.", isPopup: true, autoClose: 1600 }));
    }
  },[dispatch, onResolved, syncWeather]);

  useEffect(() => {
    if (!enabled || requestedRef.current) return;
    requestedRef.current = true;

    const locationPos = async() => {
      const currentPos = await getCurrentLocationOptional(DEFAULT_CENTER_POS);
      if (!currentPos) {
        requestedRef.current = false;
        dispatch(actionAlert({ titMessage: "위치 권한을 허용하면 현 주소를 볼 수 있어요.", isPopup: true, autoClose: 1800 }));
        return;
      }
      const {lat, lng} = currentPos;
      getAddressFromCoords(new kakao.maps.LatLng(lat,lng));
    }
    void locationPos();
  }, [dispatch, enabled, getAddressFromCoords]);

  useEffect(() => {
    if (!enabled) {
      requestedRef.current = false;
    }
  }, [enabled]);

  return null
}
